const NODE_ENV = process.env.NODE_ENV
const serveConf = NODE_ENV || 'development'
const config = require('./' + serveConf)

export default config